import nexusProcurementHtml from '@/assets/Artifacts/nexus-procurement.html?raw'
import { buildStepNarration } from './stepNarrationCopy.js'
import {
  WEBSITE_CRM_PHASE1_THREAD_TITLE,
} from './websiteCrmDemoContent.part01.js'
import { SITE_ROOT } from './websiteCrmDemoContent.part03.js'
import { writeStep } from './websiteCrmDemoContent.part04.js'

export const WEBSITE_CRM_AI_LOG_STEPS_BUILD_SITE = [
  writeStep(
    'index.html',
    nexusProcurementHtml,
    42000,
    buildStepNarration(
      'The NexusB2B procurement site HTML is written (2,785 lines)',
      'adding the Salesforce CRM integration client',
      0,
    ),
    'js/crm-integration.js',
    0,
  ),
  writeStep(
    'js/crm-integration.js',
    `/** RFQ form → Salesforce CRM lead API */
export async function submitRfqLead(payload) {
  const res = await fetch('/api/v1/salesforce/leads', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error('CRM lead sync failed');
  return res.json();
}`,
    2800,
    undefined,
    'tests/demo-user-checkout.spec.js',
    1,
  ),
  writeStep(
    'tests/demo-user-checkout.spec.js',
    `test('demo user bulk RFQ checkout', async ({ page }) => {
  await page.goto('/');
  await page.getByRole('link', { name: 'Enterprise Laptops' }).click();
  await page.getByText('Dell Latitude 5540').click();
  await page.getByLabel('Quantity').fill('50');
  await page.getByRole('button', { name: 'Add to Quote' }).click();
  await page.getByRole('button', { name: 'Submit RFQ' }).click();
  await expect(page.getByText('Quote submitted')).toBeVisible();
});`,
    3200,
    buildStepNarration(
      'The Playwright demo-user test spec is in place',
      'building the static site',
      2,
    ),
    undefined,
    2,
  ),
  {
    durationMs: 18600,
    actionName: 'Finished running command',
    arguments: { command: `cd ${SITE_ROOT} && npm run build` },
    result: {
      log: '✅ built in 4.2s\n  dist/index.html  248 kB',
      exitCode: 0,
    },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      '✅ Milestone — static site build completed without errors',
      'opening the HTML site in the preview panel',
      3,
    ),
  },
  {
    durationMs: 1200,
    actionName: 'Loaded show_user_preview',
    arguments: {
      tools: [{ toolName: 'show_user_preview' }],
    },
    result: {
      status: 'loaded',
      tools: [{ connectionId: null, toolName: 'show_user_preview' }],
    },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'Preview panel is ready for the NexusB2B site',
      'loading the rename chat tool',
      4,
    ),
  },
  {
    durationMs: 1200,
    actionName: 'Loaded rename_chat',
    arguments: {
      tools: [{ toolName: 'rename_chat' }],
    },
    result: {
      status: 'loaded',
      tools: [{ connectionId: null, toolName: 'rename_chat' }],
    },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'Rename chat is loaded',
      `titling this thread ${WEBSITE_CRM_PHASE1_THREAD_TITLE}`,
      5,
    ),
  },
  {
    durationMs: 400,
    actionName: 'Chat renamed.',
    arguments: {
      toolName: 'rename_chat',
      args: { new_title: WEBSITE_CRM_PHASE1_THREAD_TITLE },
    },
    result: { message: `Chat renamed to: "${WEBSITE_CRM_PHASE1_THREAD_TITLE}"` },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      `This chat is now titled ${WEBSITE_CRM_PHASE1_THREAD_TITLE}`,
      'wrapping up the website delivery',
      0,
    ),
  },
]

/** Full build including CRM tests — used by Phase 2 connect narrative. */
